import * as React from 'react';
import { connect } from 'react-redux';
import { Redirect, RouteComponentProps } from 'react-router-dom';

import { IRootState } from 'app/shared/reducers';
import { login } from 'app/shared/reducers/authentication';
import HomeLanding from './home-landing';

export interface ILoginProps extends StateProps, DispatchProps, RouteComponentProps<{}> {}

export class Login extends React.Component<ILoginProps> {
  handleLogin = (username, password, rememberMe = false) => {
    this.props.login(username, password, rememberMe);
  };

  render() {
    const { location, isAuthenticated } = this.props;
    const { from } = location.state || { from: { pathname: '/dashboard', search: location.search } };
    from.pathname = from.pathname === '/' ? '/dashboard' : from.pathname;
    if (isAuthenticated) {
      // alert(from.pathname + from.search);
      return <Redirect to={from} />;
    }
    return <HomeLanding handleLogin={this.handleLogin} loginError={this.props.loginError} />;
  }
}

const mapStateToProps = ({ authentication }: IRootState) => ({
  isAuthenticated: authentication.isAuthenticated,
  loginError: authentication.loginError
});

const mapDispatchToProps = { login };

type StateProps = ReturnType<typeof mapStateToProps>;
type DispatchProps = typeof mapDispatchToProps;

export default connect(mapStateToProps, mapDispatchToProps)(Login);
